var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pin-code-display",class:['pin-code-display--' + _vm.size, 'pin-code-display--' + _vm.variant]},[_c('span',{staticClass:"pin-code-display__code"},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }